import BaseWidget, { type BaseWidgetProps } from 'components/BaseWidget/BaseWidget';
import { useGetConnectedDevicesQuery } from 'services/devices/devices.api';
import { useGetGroupsQuery } from 'services/devices/groups/groups.api';
import DeviceGroupWidget from './widgets/DeviceGroupWidget/DeviceGroupWidget';

const EMPTY_DEVICES = [];
const EMPTY_GROUPS = [];

export default function ConnectedDeviceGroupsWidget({
  dimensions,
}: Pick<BaseWidgetProps, 'dimensions'>) {
  const { data: connectedDevices = EMPTY_DEVICES, isLoading: devicesLoading } =
    useGetConnectedDevicesQuery(undefined);
  const { data: groups = EMPTY_GROUPS, isLoading: groupsLoading } = useGetGroupsQuery(undefined);

  return (
    <BaseWidget
      widgetType="ConnectedDeviceGroups"
      dimensions={dimensions}
      isLoading={devicesLoading || groupsLoading}
      route="deviceGroupList"
      renderers={{
        ConnectedDeviceGroups: ({ dimensions: widgetDimensions, layout }) => (
          <DeviceGroupWidget
            dimensions={widgetDimensions}
            layout={layout}
            connectedDevices={connectedDevices}
            groups={groups}
          />
        ),
      }}
    />
  );
}
